exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quizReviewContainer {\n  margin: 5px;\n  min-height: 700px;\n  max-height: 700px;\n  width: 90%;\n  z-index: 10000;\n  overflow: scroll; }\n\n.not-attempt a {\n  color: red; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jenkins/hornbillfx-elms-v2/src/app/user-module/user-dashboard/user-dashboardcards/charts/quiz-review/quiz-review.component.scss
// module id = ../../../../../src/app/user-module/user-dashboard/user-dashboardcards/charts/quiz-review/quiz-review.component.scss
// module chunks = main